<mat-dialog-content data-testid="cy-start-scope">
    <div class="img-wrapper">
        <img src="assets/images/launching-runtime.png" aria-hidden="true" alt="Launch Runtime Logo" />
    </div>

    <h2 mat-dialog-title i18n="@@launch-scope-title">Launching Scope</h2>

    <p i18n="@@launch-scope-description">
        Scope will launch automatically if Scope Runtime is installed. You can close this window now.
    </p>

    <p i18n="@@download-runtime-description">
        Scope doesn't start? Please download and install Scope Runtime and try again.
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button
        class="riege-button"
        mat-stroked-button
        data-testid="cy-btn-download-runtime"
        (click)="downloadRuntime()"
        i18n="@@button-label-download-runtime"
        >Download Scope Runtime</button
    >

    <button
        class="riege-button"
        data-testid="cy-btn-close-dialog"
        mat-flat-button
        mat-dialog-close
        i18n="@@button-label-close"
        >Close</button
    >
</mat-dialog-actions>
